import React from 'react';
import PropTypes from 'prop-types';

import EmptyList from 'components-old/empty-list';
import FilterLayout from 'components-old/filter-layout';
import Form from 'components-old/form';
import ProposalGroup from './proposal-group';
import TopFilter from 'components-old/top-filter';
import TabList from 'components-old/tabs/tab-list';
import Link from 'components-old/link';
import Heading from 'components-old/heading';
import Spinner from 'components-old/spinner';
import useFetchFilteredResults from 'js/hooks/use-fetch-filtered-results';
import ProposalShortcuts from 'components-old/proposal-shortcuts/proposal-shortcuts';
import ContentContainer from 'components-old/content-container/content-container';

const ProposalListPage = ({
  emptyList,
  filterLayout,
  form,
  groups,
  title,
  sectionTitle,
  topFilter,
  fetchFilteredResultsEndpoint,
  proposalShortcuts,
  description
}) => {
  const [
    isLoading,
    {
      emptyList: emptyListState,
      filterLayout: filterLayoutState,
      groups: groupsState
    },
    fetchResults
  ] = useFetchFilteredResults(
    { emptyList, filterLayout, groups },
    fetchFilteredResultsEndpoint,
    form.endpoint,
    topFilter.timeframe
  );

  return (
    <Form className="proposal-list-page" showSubmitButton={false} {...form}>
      <ContentContainer>
        {proposalShortcuts && <ProposalShortcuts {...proposalShortcuts} />}
        {title && <h1 className="proposal-list-page--title">{title}</h1>}
        {description && (
          <p className="proposal-list-page--description">{description}</p>
        )}
      </ContentContainer>
      <FilterLayout
        className="proposal-list-page--hide-underline-overflow"
        {...filterLayoutState}
        includeBottomBorder={false}
        fetchFilteredResults={fetchResults}
        topContent={
          topFilter ? (
            <TabList className="proposal-list-page--tab-list">
              {topFilter.options.map(({ isCurrent, link }, index) => (
                <TabList.Item
                  key={link.url}
                  isCurrent={isCurrent}
                  length={topFilter.options.length}
                  index={index}
                  currentIndex={topFilter.options.findIndex(
                    ({ isCurrent }) => isCurrent
                  )}
                >
                  <Link theme={isCurrent ? Link.themes.black : []} {...link} />
                </TabList.Item>
              ))}
            </TabList>
          ) : null
        }
        isLoading={isLoading}
      >
        <React.Fragment>
          {sectionTitle && <Heading>{sectionTitle}</Heading>}
          {groupsState && groupsState.length > 0 ? (
            groupsState.map((group, index) => (
              <ProposalGroup key={group.title + String(index)} {...group} />
            ))
          ) : (
            <EmptyList {...emptyListState} />
          )}
          <Spinner isActive={isLoading} />
        </React.Fragment>
      </FilterLayout>
      <input
        type="hidden"
        id={topFilter.timeframe.id}
        name={topFilter.timeframe.name}
        value={topFilter.timeframe.value}
      />
    </Form>
  );
};

ProposalListPage.propTypes = {
  emptyList: PropTypes.exact(EmptyList.propTypes),
  filterLayout: PropTypes.exact(FilterLayout.propTypes),
  form: PropTypes.exact(Form.propTypes),
  groups: PropTypes.arrayOf(PropTypes.exact(ProposalGroup.propTypes)),
  title: PropTypes.string,
  topFilter: PropTypes.exact(TopFilter.propTypes),
  sectionTitle: PropTypes.string,
  fetchFilteredResultsEndpoint: PropTypes.string,
  proposalShortcuts: PropTypes.exact(ProposalShortcuts.propTypes),
  description: PropTypes.string
};

ProposalListPage.defaultProps = {
  groups: []
};

export default ProposalListPage;
